import fly from '@/fly'
import { Toast } from 'vant' // 引入Toast
import Setting from '@/setting';

function upLoadFileCommon(file, businessModule) { // file为 你读取成功的回调文件信息
    // new 一个FormData格式的参数
    const params = new FormData()
    params.append('file', file)
    if (businessModule) params.append('businessModule', businessModule)

    return new Promise((resolve, reject) => {
        // 把 uploadUrl 换成自己的 上传路径

        fly.upload(Setting.apiBaseURL + 'upload', params).then(res => {
            if (res) { // 如果为真 resolve出去
                resolve(res)
            } else {
                // 否则 Toast 提示
                Toast.fail('文件上传错误')
                reject(res)
            }
        }).catch(err => {
            Toast.fail('网络错误')
            reject(err)
        });
    })
}
export default upLoadFileCommon
